import { Row } from '@tanstack/react-table'
import { filterTimeIsAfter, filterTimeIsBefore } from './parseTimeFilter';

export const filterByTimeRange = <T>(
    row: Row<T>,
    columnId: string,
    filterValue: { from?: string; to?: string }
): boolean => {
    const value = row.getValue<string>(columnId)
    if (!value) return false

    const time = new Date(value)

    if (filterValue.from) {
        if (filterTimeIsBefore(time, filterValue.from)) {
            return false
        }
    }

    if (filterValue.to) {
        if (filterTimeIsAfter(time, filterValue.to)) {
            return false
        }
    }

    return true
}
